/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

const allowedKeys = new Set([
  '-',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '.',
  'Backspace',
  'Delete',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
]);

function isAllowedShortcut(ctrl: boolean, newKey: string) {
  return ctrl && ['a', 'c', 'v'].includes(newKey);
}

function isSecondDot(newKey: string, lastValue: string | undefined) {
  return newKey === '.' && lastValue?.includes('.');
}

export function isAllowedKeyForNumberInput(newKey: string, ctrl: boolean, lastValue: string | undefined): boolean {
  if (isSecondDot(newKey, lastValue)) {
    return false;
  }

  if (isAllowedShortcut(ctrl, newKey)) {
    return true;
  }

  return allowedKeys.has(newKey);
}
